var exports = {
  "iE": "wrapper__63qxs3",
  "c8": "sectionIntro__T3PlCr",
  "Ey": "stackedItems__CP-j_B",
  "Cz": "stackedItemText__o6VSE7",
  "ky": "headingText__Bq-Va9",
  "R_": "heading__yaeZBh",
};

module.exports = exports;
